import { render, staticRenderFns } from "./Croppable.vue?vue&type=template&id=0c855fa8&scoped=true&"
import script from "./Croppable.vue?vue&type=script&lang=ts&"
export * from "./Croppable.vue?vue&type=script&lang=ts&"
import style0 from "./Croppable.vue?vue&type=style&index=0&id=0c855fa8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c855fa8",
  null
  
)

export default component.exports